import React, { useState } from "react";
import { HexColorPicker } from "react-colorful";
import { Box, IconButton, Stack, TextField, Popover } from "@mui/material";
import { isError, getErrorMsg } from "../../../helper/FormHelper.jsx";

export default function FormikColorPicker({ formik, elementContent }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const fieldId = elementContent?.props?.id;
  const fieldLabel = elementContent?.props?.label || "Color";
  const colorValue = formik?.values?.[fieldId] || "#000000";

  const handleOpenPicker = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosePicker = () => {
    setAnchorEl(null);
  };

  const handleColorChange = (newColor) => {
    formik.setFieldValue(fieldId, newColor);
  };

  const handleTextChange = (event) => {
    formik.setFieldValue(fieldId, event.target.value);
  };

  const hasError = isError(formik, fieldId);

  return (
    <Box>
      <Stack direction="row" spacing={1} alignItems="center">
        {/* LEFT: square color swatch button that opens the picker */}
        <IconButton
          onClick={handleOpenPicker}
          sx={{
            width: 56,
            height: 56,
            borderRadius: 1,
            border: "1px solid",
            borderColor: hasError ? "error.main" : "grey.400",
            bgcolor: colorValue,
            flexShrink: 0,
            "&:hover": { opacity: 0.85 },
          }}
        />

        {/* RIGHT: editable hex value text field */}
        <TextField
          fullWidth
          label={fieldLabel}
          value={colorValue}
          onChange={handleTextChange}
          onBlur={() => { formik.touched[fieldId] = true; }}
          error={hasError}
          helperText={getErrorMsg(formik, fieldId)}
        />
      </Stack>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClosePicker}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <Box sx={{ p: 2 }}>
          <HexColorPicker color={colorValue} onChange={handleColorChange} />
        </Box>
      </Popover>
    </Box>
  );
}
